<template>
  <div>
    <program-template-index
      :formSearch="formSearch"
      :enableExport="false"
      :hide-action="false"
      :columns="columns"
      :title="$t('menu.program_template_list')"
      :serviceName="serviceName"
    />
  </div>
</template>

<script>
import ProgramTemplateIndex from "./ProgramTemplateIndex";
import { CriterionCategoriesService } from "../../../services/criterionCategories.service";
import { ProgramDivisionService } from "../../../services/programDivision.service";
import { ProgramTypeService } from "../../../services/programType.service";

export default {
  name: "Index",
  data() {
    return {
      serviceName: "template",
      formSearch: [
        {
          label: this.$t("program_template.name"),
          name: "name__~",
          value: "",
          type: "input"
        },
        {
          label: this.$t("program_template.program_division_name"),
          name: "program_division_id",
          value: "",
          type: "select",
          options: []
        },
        {
          label: this.$t("program_template.program_type_name"),
          name: "program_type_id",
          value: "",
          type: "select",
          options: []
        }
      ],
      columns: {
        id: this.$t("program_template.id"),
        name: this.$t("program_template.name"),
        program_division_name: this.$t(
          "program_template.program_division_name"
        ),
        program_type_name: this.$t("program_template.program_type_name"),
        created_at: this.$t("program_template.created_at"),
        updated_at: this.$t("program_template.updated_at")
      }
    };
  },
  components: { ProgramTemplateIndex },
  methods: {
    async getProgramDivisionOptions() {
      const response = await new ProgramDivisionService().getList({
        limit: 1000
      });
      this.formSearch[1].options = response.data || [];
      return response.data;
    },
    async getProgramTypeOptions() {
      const response = await new ProgramTypeService().getList({
        limit: 1000
      });
      this.formSearch[2].options = response.data || [];
      return response.data;
    }
  },
  created() {
    this.getProgramDivisionOptions();
    this.getProgramTypeOptions();
  }
};
</script>
